<template>
	<div class="card">
		<div class="card-body">
			<div class="row align-items-center">
				<div class="col-md-2 col-6">
					<base-input label="วันที่">
						<flat-picker class="form-control datepicker" v-model="startDate" />
					</base-input>
				</div>
				<div class="col-md-2 col-6">
					<base-input label="ถึง">
						<flat-picker class="form-control datepicker" v-model="endDate" />
					</base-input>
				</div>
				<div class="col-md-2 col-6">
					<base-input label="เรียงจาก" required>
						<el-select v-model="orderBy">
							<el-option label="ยอดฝาก" value="deposit" />
							<el-option label="ยอดถอน" value="withdraw" />
							<el-option label="กำไร/ขาดทุน" value="diff" />
						</el-select>
					</base-input>
				</div>
				<div class="col-md-6 col-12 search">
					<base-button type="default" @click="submitSearch()" :disabled="loading">
						ค้นหา
					</base-button>
				</div>
			</div>

			<div class="row mt-4">
				<div class="col-md-8">
					<report-by-member-panel :data="reports" :orderBy="orderBy" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { Select, Option } from 'element-ui'
import flatPicker from 'vue-flatpickr-component'
import ReportByMemberPanel from '../backend-components/Summary/ReportByMemberPanel'

import moment from 'moment'
import SummaryService from '../services/summary.service'

export default {
	components: {
		[Select.name]: Select,
		[Option.name]: Option,
		flatPicker,
		ReportByMemberPanel,
	},
	data() {
		return {
			startDate: moment().format('YYYY-MM-DD'),
			endDate: moment().format('YYYY-MM-DD'),
			orderBy: 'deposit',

			loading: false,
			reports: [],
		}
	},
	methods: {
		async submitSearch() {
			this.loading = true
			try {
				const res = await SummaryService.summaryReportByMember({
					start: this.startDate,
					end: this.endDate,
				})
				this.reports = res
			} catch ({ message }) {
				this.$notify({ type: 'danger', message })
			} finally {
				this.loading = false
			}
		},
	},
	created() {
		this.submitSearch()
	},
}
</script>
